import type { PblAssignmentRespondPayload, PblAuthUser, PblCase, PblCaseAssignment } from '@/types/pbl';

export type LawyerAssignmentDecision = 'accept' | 'decline';

const getCurrentLawyerProfileId = (userData?: Pick<PblAuthUser, 'pbl_lawyer_profile'> | null) =>
  userData?.pbl_lawyer_profile?.id;

const getAssignmentLawyerProfileId = (assignment: PblCaseAssignment) =>
  assignment.pbl_lawyer_profile_id ?? assignment.lawyer_profile_id ?? assignment.lawyer_profile?.id;

const respondableAssignmentStatuses = new Set(['invited', 'pending']);

const isRespondableLawyerAssignment = (assignment: PblCaseAssignment) =>
  respondableAssignmentStatuses.has(assignment.status);

export const findCurrentPendingLawyerAssignment = (
  pblCase?: Pick<PblCase, 'assignments'> | null,
  userData?: Pick<PblAuthUser, 'pbl_lawyer_profile'> | null
) => {
  const respondableAssignments = pblCase?.assignments?.filter(isRespondableLawyerAssignment) || [];
  const currentLawyerProfileId = getCurrentLawyerProfileId(userData);

  if (currentLawyerProfileId) {
    return respondableAssignments.find((assignment) => getAssignmentLawyerProfileId(assignment) === currentLawyerProfileId);
  }

  return respondableAssignments[0];
};

export const buildLawyerAssignmentResponsePayload = (
  decision: LawyerAssignmentDecision,
  declineReason?: string
): PblAssignmentRespondPayload => {
  if (decision === 'accept') return { response: 'accept' };

  return {
    response: 'decline',
    decline_reason: declineReason?.trim() || '',
  };
};
